import { RedirectPaths, RedirectPathsEnum } from '@/common/constants';
import OnboardingSuccessImg from '@/images/security-profile/onboarding-success.png';
import { AppButton } from '@/ui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import {
  StyledOnboardingContainer,
  StyledOnboardingDescription,
  StyledOnboardingOverlay,
  StyledOnboardingTitle,
  StyledSuccessImage,
  StyledWatermark,
} from './styles';

const StyledSecurityProfileButton = styled.button`
  background: none;
  cursor: pointer;
  font-size: inherit;
  font-family: inherit;
  font-weight: inherit;
  color: inherit;
  padding: 0;
  border: none;
  border-bottom: 1px solid var(--red-main);

  &:hover {
    border-bottom-color: var(--red-dark);
  }
`;

const StyledSuccessContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--xsmall-padding);
  text-align: center;
  max-width: 613px;
`;

const StyledSuccessTitleBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--medium-big-padding);
  text-align: center;
`;

const StyledSuccessDescription = styled(StyledOnboardingDescription)`
  text-align: center;
`;

type OnboardingSuccessProps = {
  onContinue: () => void;
};

export const OnboardingSuccess: React.FC<OnboardingSuccessProps> = ({
  onContinue,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <StyledOnboardingOverlay>
      <StyledOnboardingContainer>
        <StyledSuccessContent>
          <StyledSuccessImage>
            <img src={OnboardingSuccessImg} alt="" />
          </StyledSuccessImage>
          <StyledSuccessTitleBlock>
            <StyledOnboardingTitle style={{ textAlign: 'center' }}>
              {t('securityProfile.onboarding.completed')}
            </StyledOnboardingTitle>
            <StyledSuccessDescription>
              {t('securityProfile.onboarding.completedDescription')}
              <StyledSecurityProfileButton
                onClick={() => {
                  onContinue();
                  navigate(
                    RedirectPaths[RedirectPathsEnum.ACCOUNT_SECURITY_PROFILE](),
                  );
                }}
              >
                {t('securityProfile.onboarding.securityProfile')}
              </StyledSecurityProfileButton>
              {'.'}
            </StyledSuccessDescription>
          </StyledSuccessTitleBlock>
        </StyledSuccessContent>

        <AppButton
          onClick={onContinue}
          label={t('securityProfile.onboarding.continueToPlatform')}
        />
        <StyledWatermark aria-hidden="true">CyberPilot</StyledWatermark>
      </StyledOnboardingContainer>
    </StyledOnboardingOverlay>
  );
};
